import HasAttachableClassEnum from "../../../enums/HasAttachableClassEnum";

export default {
  CUSTOMER: HasAttachableClassEnum.CUSTOMER,
  POLICY: HasAttachableClassEnum.POLICY,
  DAMAGE: HasAttachableClassEnum.DAMAGE,
  MORTGAGE: HasAttachableClassEnum.MORTGAGE,
  MORTGAGE_PART: HasAttachableClassEnum.MORTGAGE_PART,
  OBLIGATION: HasAttachableClassEnum.OBLIGATION,
  TASK: HasAttachableClassEnum.TASK,
};
